import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LargeLoadingIcon = ({ sx, ...props }: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 61 60" sx={{width: '61px', height: '60px', ...sx}} {...props}>
            <path
                d="M30.5 5.625V11.875M30.5 45V55M14.875 30H6.125M53.625 30H49.875M46.6428 46.1428L44.875 44.375M47.1605 13.5395L43.625 17.075M12.8039 47.6961L19.875 40.625M13.3217 13.0217L18.625 18.325"
                stroke="black" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    );
};

export default LargeLoadingIcon;
